import Vue from 'vue'
import VueApollo from 'vue-apollo'
import ApolloClient from 'apollo-client'
import {ApolloLink} from 'apollo-link';
import {HttpLink} from "apollo-link-http";
import {InMemoryCache} from "apollo-cache-inmemory";
import {setContext} from 'apollo-link-context'
import {onError} from "apollo-link-error";
import router from "../routes/routes";
import store from '../store'

const httpLink = new HttpLink({
  // uri: 'https://master.epgeditor.com/graphql',
  uri: process.env.GRAPHQL_ENDPOINT,
});

const authLink = setContext(async (_, {headers}) => {
  const token = localStorage.getItem('auth-token');
  // console.log('putting in context token: ' + token)
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${token}`
    }
  }
})

const errorHandler = onError(({networkError, graphQLErrors}) => {
  console.log({graphQLErrors, networkError})
  if (networkError && networkError.result && networkError.result.message) {
    store.dispatch('setErrorMessages', [{message: networkError.result.message}])
  }
  if (graphQLErrors && graphQLErrors.length) {
    console.log(graphQLErrors);
    let validationMessages = [];
    graphQLErrors.forEach((error, index) => {
        if (error.extensions && error.extensions.category) {
          if (error.extensions.category === 'authentication') {
            store.dispatch('logoutOffline');
            router.push({name: 'login'});
          }
          if (error.extensions.category === 'validation' && error.extensions.validation) {
            graphQLErrors.splice(index, 1);
            for (const [key, validationMessage] of Object.entries(error.extensions.validation)) {
              validationMessages = validationMessages.concat(validationMessage);
            }
          }
        }
      }
    );
    const errorMessages = [...graphQLErrors, ...validationMessages];
    store.dispatch('setErrorMessages', errorMessages)
  }
})


export const apolloClient = new ApolloClient({
  link: ApolloLink.from([errorHandler, authLink, httpLink]),
  cache: new InMemoryCache({
    addTypename: true
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
    },
    query: {
      fetchPolicy: 'no-cache',
    }
  }
});

// Install the Vue plugin
Vue.use(VueApollo)

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})





// WEBPACK FOOTER //
// ./src/graphql/apollo.js